// modulo  paginator
// https://github.com/cornflourblue/react-pagination-example
// Css bootstrap https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css
import React from 'react';
const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";

const stylesBlock = {

      title:{ 
            
            fontWeight:'bold',
            color:'red',
            fontSize:'20px'
       },
       titleDescr:{
            
            fontWeight:'bold',
            fontSize:'18px',
            width:'auto',
       },
       descr:{
            color:'grey',
            fontWeight:'normal',
            fontSize:'18px'
       },
      compareBlock_:{
            backgroundColor: "#ffffff",
            marginBottom:'30px'
    } ,
    dividerLeft:{ height:'1px',backgroundColor:'#dddddd',width:'50%',float:'right' },
    dividerRight:{ height:'1px',backgroundColor:'#dddddd',width:'50%',float:'left' }
}

class CompareBlock extends React.Component {



    constructor(props) {
        super(props);
        this.state = { };


    }
    componentDidMount() { }
  
    render() {
       
        return (
            <div className={'compareDataBlock'} style={ stylesBlock.compareBlock_ }>
                  <p style={ stylesBlock.title } >{ this.props.titleCompare }</p>

                  {
                        this.props.blockType == '1' && (
                              <div className={'row'} style={{ margin:'0px',paddingBottom:'10px' }} >
                              <div className={'col-6 fixing  '} style={{ textAlign:'right',borderRight:'1px solid #dddddd' }}>
                                    <p style={ stylesBlock.titleDescr } > { this.props.titleColLeft } </p>
                                    <p style={ stylesBlock.descr }> { this.props.dataLeft } </p>

                                    {
                                          this.props.titleColLeft_2   &&(
                                                <div>
                                                   <div style={{width:'100%',display:'inline-block'}}>
                                                            <div style={stylesBlock.dividerLeft}></div>
                                                      </div>
                                                      <p style={ stylesBlock.titleDescr }> { this.props.titleColLeft_2 } </p>
                                                      <p style={ stylesBlock.descr }> { this.props.dataLeft_2 } </p>
                                                      </div>
                                          )
                                    }
                                 
                              </div>
                              <div className={'col-6 fixing'} style={{ textAlign:'left' }}>
                                   <p style={ stylesBlock.titleDescr }> { this.props.titleColRight }</p>
                                   <p style={ stylesBlock.descr }> { this.props.dataRight } </p>
                                    {
                                          this.props.titleColRight_2   && (
                                                <div>
                                                    <div style={{width:'100%',display:'inline-block'}}>
                                                      <div style={stylesBlock.dividerRight}></div>
                                                </div>
                                                <p style={ stylesBlock.titleDescr }> { this.props.titleColRight_2 }</p>
                                                <p style={ stylesBlock.descr }> { this.props.dataRight_2 } </p>
                                                </div> 
                                          )
                                    }
                               
                              </div> 
                        </div>
                        )
                  }
                  {

                        

                        this.props.blockType == '2' && (
                              <div className={'row'} style={{ margin:'0px' }} >
                              <div className={'col-6 fixing'} style={{ borderRight:'1px solid #dddddd',display:'flex',flexDirection:'row-reverse' }}>
                              {
 
                                    [1,2,3,4,5].map( (item,index) => {
 
                                          let colorIcon = 'grey'; 
                                          if( index < parseInt(this.props.dataLeft) )  {
                                                colorIcon = 'red'
                                          } 
                                          return( <p  key={index}>
                                                <img style={{ width:'22px' }} src={ASSETS_BASE + `/images/bone_${colorIcon}.png`  } />
                                                </p> )
                                    }) 
                              }
          
                              </div>
                              <div className={'col-6 fixing  '} style={{ display:'flex',flexDirection:'row'  }}>
                              {
                                    //   `a=${a}, b=${b}, c=${c}`
                                    // images/bone_grey.png 
                                    [1,2,3,4,5].map( (item,index) => {
 
                                          let colorIcon = 'grey'; 
                                          if( index < parseInt(this.props.dataRight) )  {
                                                colorIcon = 'red'
                                          } 
                                          return( <p  key={index}>
                                                <img style={{ width:'22px' }} src={ASSETS_BASE + `/images/bone_${colorIcon}.png`  } />
                                                </p> )
                                    })
                              }
                              </div> 
                        </div>
                        )
                  }

                 
            </div>
        );
    }
} 

export default CompareBlock;